import type { AnalyticsObject, AnalyticsProperties } from '../types'

export class ChecklistItem implements AnalyticsObject {
  name: string
  properties: ChecklistItemProperties
  constructor(properties: ChecklistItemProperties) {
    this.name = 'Checklist Item'
    this.properties = properties
  }
}

export interface ChecklistItemProperties extends AnalyticsProperties {
  checklistId: string
  checklistTitle: string
  checklistItemTitle: string
}
